import * as angular from 'angular';
import 'angular-file-saver';
import 'angular-ui-router';
import permissions from 'application/detail/permissions.json';
import { pipeActionTabComponents } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components';
import { BuilderQueuesComponent } from './attendanceRules/queues';
import { BuilderRulesComponent } from './attendanceRules/rules';
import { BuilderController } from './BuilderController';
import BuilderView from './BuilderView.html';
import { ActionContentService } from './services/ActionContentService';
import { BuilderContentService } from './services/BuilderContentService';
import { BuilderSegmentService } from './services/BuilderSegmentService';
import { BuilderService } from './services/BuilderService';
import { LockService } from './services/LockService';
import { BuilderStateService } from './services/BuilderStateService';
import { BuilderTabsService } from './services/BuilderTabsService';
import { CodeEditorService } from './services/CodeEditor/CodeEditorService';
import { JsPlumbService } from './services/JsPlumbService';
import { SavingService } from './services/SavingService';
import { SubflowService } from './services/SubflowService';
import { SmartSalesService } from './services/SmartSalesService';
import { TagsService } from './services/TagsService';
import { VariablesService } from './services/VariablesService';
import { CopilotAdapterService } from './services/CopilotAdapterService';
import { ExclusiveComponentsService } from './services/ExclusiveComponentsService';
import { FunctionService } from './services/FunctionService';
import { ActionService } from './services/ActionService';
// Constants
export const pipelineStateName = 'auth.application.detail.pipeline.index';
export const pipelineDefaultStateName = 'auth.application.detail.pipeline';
export const templatePipeline = angular
    .module('pipeline', ['ngFileSaver', pipeActionTabComponents])
    .service('PipelineSubflowService', SubflowService)
    .service('PipelineSmartSalesService', SmartSalesService)
    .service('PipelineExclusiveComponentsService', ExclusiveComponentsService)
    .service('PipelineLockService', LockService)
    .service('PipelineBuilderService', BuilderService)
    .service('PipelineFunctionService', FunctionService)
    .service('PipelineActionService', ActionService)
    .service('PipelineBuilderStateService', BuilderStateService)
    .service('PipelineJsPlumbService', JsPlumbService)
    .service('PipelineSavingService', SavingService)
    .service('PipelineBuilderContentService', BuilderContentService)
    .service('PipelineTagsService', TagsService)
    .service('PipelineVariablesService', VariablesService)
    .service('PipelineCodeEditorService', CodeEditorService)
    .service('PipelineBuilderSegmentService', BuilderSegmentService)
    .service('PipelineBuilderTabsService', BuilderTabsService)
    .service('PipelineActionContentService', ActionContentService)
    .service('PipelineCopilotAdapterService', CopilotAdapterService)
    .component('pipeBuilderAttendanceQueue', BuilderQueuesComponent)
    .component('pipeBuilderAttendanceRules', BuilderRulesComponent)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(pipelineDefaultStateName, {
            url: '/templates/pipeline?appcue&selectedNodeId',
            redirectTo: pipelineStateName,
            data: {
                permissionClaim: permissions.builder.claim,
            },
        })
            .state(pipelineStateName, {
            url: '/:callerSubflow',
            views: {
                'content@auth.application.detail': {
                    template: BuilderView,
                    controller: BuilderController,
                    resolve: {
                        loadJsplumb: ['$q', ($q) => {
                                const deferred = $q.defer();
                                import(/* webpackChunkName: "jsplumb" */ 'jsplumb')
                                    .then((script) => {
                                    deferred.resolve(script);
                                })
                                    .catch((e) => {
                                    console.error(e);
                                });
                                return deferred.promise;
                            }],
                    },
                    controllerAs: '$ctrl',
                },
            },
            params: { area: 'builder' },
        });
    }]).name;
